import ViewContainer from './components/ViewContainer';

export default () => <ViewContainer />;
